// eslint:disable:no-console
import * as React from 'react';
import { FirebaseMessaging } from '@firebase/messaging-types';
import { MessagingProviderState, Callback } from './types';
import { FmcContext } from './context';
import { notifyUser } from 'app/infrastructure/notifications/notify-user';
import { initFmc } from 'app/infrastructure/push/init';
import { configurationAccess } from 'app/area/user-profile/my-notifications/configuration-access';
import { webPushCertificate } from 'app/infrastructure/push/configuration-data';

export class MessagingProvider extends React.Component<React.PropsWithChildren, MessagingProviderState> {
  public state: Readonly<MessagingProviderState> = {
    fmcToken: '',
    fmcMessaging: undefined
  };

  private postInitFmc = async (fmcMessaging: FirebaseMessaging) => {
    try {
      configurationAccess.push && webPushCertificate && await Notification.requestPermission();
      const fmcToken = await fmcMessaging.getToken();
      await fmcMessaging.onTokenRefresh(this.onTokenRefresh);
      this.setState({ fmcToken: fmcToken, fmcMessaging });
    } catch (err) {
      if (err.code === 'messaging/token-unsubscribe-failed') {
        await this.postInitFmc(fmcMessaging);
      }
    }
  };

  public componentDidMount() {
    initFmc().then(this.postInitFmc);
  }

  private executeCallback = async (callback: Callback) => {
    const token = await this.state.fmcMessaging.getToken();
    console.log('token: ', token);
    callback(token);
  };

  private requestPermission = async (callback: Callback) => {
    try {
      await this.state.fmcMessaging.requestPermission();
      await this.executeCallback(callback);
    } catch (err) {
      err && notifyUser.error(err);
    }
  };

  private onTokenRefresh = async () => {
    try {
      const refreshedToken = await this.state.fmcMessaging.getToken();
      console.log('Token refreshed.', refreshedToken);
    } catch (err) {
      console.log('Unable to retrieve refreshed token ', err);
    }
  };

  public render() {
    return (
      <FmcContext.Provider value={{ state: this.state, requestPermission: this.requestPermission }}>
        {this.props.children}
      </FmcContext.Provider>
    );
  }
}
